import { render, staticRenderFns } from "./ForgetVerificationOTP.vue?vue&type=template&id=cce513c8&lang=html"
import script from "./ForgetVerificationOTP.vue?vue&type=script&lang=js"
export * from "./ForgetVerificationOTP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports